import React, { useState, ReactElement, FC } from 'react';
import styled from '@emotion/styled';
import { TabProps } from './Tab';

interface SecondaryTabProps {
  children: ReactElement<TabProps>[];
}

const TabHeaderContainer = styled.nav`
  width: 100%;
  height: 35px;
  background: #fff;
  display: flex;
`;

const NavItem = styled.div<{ selected: boolean; beforeSelected: boolean }>`
  background-color: ${s => (s.selected ? '#0076CE' : '#fff')};
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  font-size: 12px;
  cursor: pointer;
  color: ${s => (s.selected ? '#fff' : '#0076CE')};
  font-weight: 600;
  border-style: solid;
  border-left: none;
  border-top-width: 1px;
  border-top-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-right-width: ${p => (p.beforeSelected ? '0' : '1px')};
  border-color: ${p => (p.selected ? '#0076CE' : '#e4e4e4')};

  &:first-of-type {
    border-left-width: 1px;
    border-left-style: solid;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const TabContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const SecondaryTabs: FC<SecondaryTabProps> = ({ children }) => {
  if (!children || React.Children.count(children) === 0) {
    throw new Error('Secondary Tabs requires children of Tab type.');
  }

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const changeTab = (tabIndex: number) => {
    setCurrentTabIndex(tabIndex);
  };
  const isBeforeSelected = (tabIndex: number) => {
    const distance = currentTabIndex - tabIndex;
    return distance === 1;
  };
  return (
    <>
      <TabHeaderContainer>
        {React.Children.map(children, (child, tabIndex) => {
          return (
            <NavItem
              selected={currentTabIndex === tabIndex}
              beforeSelected={isBeforeSelected(tabIndex)}
              key={tabIndex}
              onClick={() => {
                changeTab(tabIndex);
              }}
            >
              {child && child.props && <span>{child && child.props.title}</span>}
            </NavItem>
          );
        })}
      </TabHeaderContainer>

      <TabContent>{children[currentTabIndex].props.children}</TabContent>
    </>
  );
};

export default SecondaryTabs;
